<template>
    <common-layout-component2 show-back="false" show-user="false">

        <template v-slot:nav-message>
            <p>カテゴリ選択</p>
        </template>

        <template v-slot:nav-ctrl>
            <!--<p>
                <a href="#" class="button basic is-gray">更新日順&nbsp;<img src="/e-learning/images/ico-down.png" alt=""></a>
                <a href="#" class="button basic is-gray">五十音順&nbsp;<img src="/e-learning/images/ico-down.png" alt=""></a>
                <a href="#" class="button is-login rs">タグ検索</a>
            </p>-->
        </template>


        <template v-slot:body>
            <div class="container">
                <div class="columns is-multiline cat-wrapper">
                    <template v-for="item in categories">
                        <div class="column is-half cat-item" v-bind:class="{'no-task': item.total_tasks == 0}">
                            <a href="#" v-show="item.total_tasks == 0">
                                <h2>{{ item.category_name }}</h2>
                            </a>
                            <router-link v-show="item.total_tasks > 0" v-bind:to="'/user/tasks/' + item.category_id">
                                <h2>{{ item.category_name }}</h2>
                            </router-link>
                        </div>
                    </template>

                </div>
            </div>
        </template>
    </common-layout-component2>
</template>
<script>
    import CommonLayoutComponent2 from '../../commons/CommonLayoutComponent2.vue';
    export default {
        mounted: function() {
            var res = Vue.ELearning.Category.getValid();

            res.then(function(res){
                var content = res.data;

                console.log(content);
                this.categories = content.content;
            }.bind(this)).catch(function(err){
                console.log(err);
            });
        },
        data: function() {
            return {
                categories: []
            };
        },
        computed: {
            currentGrant: function() {

                console.log("grant", this.$store.state.userInfo);
                return this.$store.state.userInfo.grant;
            }
        },

        methods: {
            /*navTo: function(path, grant) {
                if(grant > this.currentGrant) {
                    return;
                }

                this.$router.push({'path':path});
            },*/
            gotoTask(pathObj) {
                console.log(pathObj);
                this.$router.push(pathObj);
            }
        },

        components: {
            CommonLayoutComponent2,
        },
    }
</script>
<style lang='scss' scoped>

    .cat-item a {
        text-decoration: none;
    }
    .no-task {
      display: none;
    }
</style>
